import { render, staticRenderFns } from "./ProofreadingSelectTypePage.vue?vue&type=template&id=1652e944"
import script from "./ProofreadingSelectTypePage.vue?vue&type=script&lang=ts"
export * from "./ProofreadingSelectTypePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1652e944')) {
      api.createRecord('1652e944', component.options)
    } else {
      api.reload('1652e944', component.options)
    }
    module.hot.accept("./ProofreadingSelectTypePage.vue?vue&type=template&id=1652e944", function () {
      api.rerender('1652e944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/ProofreadingSelectTypePage.vue"
export default component.exports